import React from "react";
import { Icon } from "react-native-elements";
import THEME from '../../config/theme';
import Button from '../../components/Button';
import { StandardText, SmallText, Container } from "../../config/theme/globalStyles";
import { useAuthUser } from "../../contexts/useAuthUser";
import { CommonActions } from '@react-navigation/native';

export function Success({ navigation }) {
  // A sessão já foi resolvida no boot, então não há espera aqui. Mantém o
  // critério original (`if (user)`), que considera logado inclusive a sessão
  // anônima criada durante a compra.
  const { authUser } = useAuthUser();
  const login = !!authUser;

  return (
    <Container justifyContent="center">
      <Icon
        type="material-icons"
        name="check-circle-outline"
        color={THEME.COLORS.PRIMARY_900}
        size="60px"
      />
      {login ?
        <>
          <StandardText color={THEME.COLORS.PRIMARY_900} margin="1rem 0rem">Compra realizada com sucesso!</StandardText>
          <SmallText color={THEME.COLORS.PRIMARY_900} margin="0rem 0rem 3rem 0rem">Clique no botão abaixo para acessar os conteúdos!</SmallText>
          <Button
            title={"Acesse os conteúdos"}
            onPress={() =>
              navigation.dispatch(
                CommonActions.reset({
                  index: 1,
                  routes: [{ name: "Conteudo" }],
                }))}
          >
          </Button>
        </>
        :
        <>
          <StandardText color={THEME.COLORS.PRIMARY_900} margin="1rem 0rem">Compra realizada com sucesso!</StandardText>
          <SmallText color={THEME.COLORS.PRIMARY_900} margin="0rem 0rem 3rem 0rem">Faça o seu primeiro login.</SmallText>
          <Button
            title={"Fazer Login"}
            onPress={() =>
              navigation.dispatch(
                CommonActions.reset({
                  index: 1,
                  routes: [{ name: 'Login' }],
                }))}
          >
          </Button>
        </>
      }
    </Container>
  );
};